'use strict';

intellidealerAppCoreModule.controller('BadStateController', function ($scope, $state, library) {
  if (library) {
    $state.go('login', {library:library});
  }
});
